import React, { useState, useEffect } from 'react'
import { Card, message, Typography } from 'antd'
import AdminTable from '../../components/common/AdminTable'
import api from '../../utils/api'
import { formatTz } from '../../utils/timezone'

const { Title } = Typography

const UsersList = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 0,
    totalItems: 0,
    itemsPerPage: 10
  })

  const columns = [
    {
      title: '用戶名稱',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: '電子郵件',
      dataIndex: 'email',
      key: 'email'
    },
    {
      title: '電話',
      dataIndex: 'phone',
      key: 'phone'
    },
    {
      title: '註冊時間',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (date) => formatTz(date, 'YYYY/MM/DD')
    }
  ]

  const fetchData = async (page = 1, pageSize = 10) => {
    setLoading(true)
    try {
      const response = await api.get(
        `/api/admin/users?page=${page}&limit=${pageSize}`
      )
      setData(response.data.data)
      setPagination(response.data.pagination)
    } catch (error) {
      message.error('獲取用戶數據失敗')
    }
    setLoading(false)
  }

  useEffect(() => {
    fetchData()
  }, [])

  const handleTableChange = (pagination) => {
    fetchData(pagination.current, pagination.pageSize)
  }

  return (
    <Card>
      <Title level={2}>用戶管理</Title>
      <AdminTable
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={pagination}
        onChange={handleTableChange}
      />
    </Card>
  )
}

export default UsersList
